import * as icon from "@coreui/icons";

export const singleCountriesOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      const phone_code = item && item.phone_code
      const country_code = item && item.country_code
      if (phone_code) {
        options.push({
          label: name,
          value: JSON.stringify({
            id: id,
            name: name,
            icon: icon[`cif${country_code}`],
            phone_code: phone_code,
          })
        })
      }
    })
    options = [
      ...options,
    ]
  }
  return options
};

export const singleGamesOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.game_name
      options.push({
        label: name,
        value: id
      })
    })
    options = [
      ...options,
    ]
  }
  return options
}

export const singleVoucherTypeOptionSelect = () => {
  return [
    {
      label: 'MLWDP',
      value: 'mlwdp'
    },
    {
      label: 'Game Pass',
      value: 'gamepass'
    }
  ]
}

export const singleIsUsedOptionSelect = () => {
  return [
    {
      label: 'Yes',
      value: true
    },
    {
      label: 'No',
      value: false
    }
  ]
}

export const singleIsExpiredOptionSelect = () => {
  return [
    {
      label: 'Expired',
      value: true
    },
    {
      label: 'Available',
      value: false
    }
  ]
}